import { useToast } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import { patientHistoryList } from 'api/auth.api';

const getErrorMessage = (error, fallback) => {
  const msg = error?.response?.data?.message;
  if (typeof msg === 'string') return msg;
  if (typeof msg === 'object' && msg?.message) return msg.message;
  return fallback;
};

export const usePatientHistoryList = (
  page,
  searchString = '',
  doctorId,
  filters = {},
) => {
  const toast = useToast();

  const { data, isLoading, isFetching } = useQuery({
    queryKey: ['patientHistoryList', page, searchString, doctorId, filters],
    queryFn: () =>
      patientHistoryList({
        page,
        searchString,
        doctorId,
        ...filters,
      }),
    select: (res) => res?.data || {},
    onError: (error) => {
      toast({
        title: getErrorMessage(error, 'Failed to fetch list'),
        status: 'error',
      });
    },
  });

  return {
    patientHistory: data?.result || [],
    totalPages: data?.totalPages || 1,
    isLoading: isLoading || isFetching,
  };
};
